<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="영양팀">
            <div class="vx-row">
                <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="updateDate(-1)"></vs-button>
                    <span class="ml-5 mr-5"> {{ date }} ({{ day }}) </span>
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="updateDate(1)"></vs-button>
                </div>
            </div>
            <vs-button type="line" class="activeMenu">입원일 식이</vs-button>
            <div class="flex justify-end flex-wrap mb-3"></div>
            <div class="tb_wrap">
                <div class="tb_box" id="list" style="width:100%;overflow-x:auto; height:900px;">
                    <table style="width:100%;" class="border-collapse">
                        <colgroup>
                            <col width="100" />
                            <col width="190" />
                            <col width="160" />
                            <col width="120" />
                            <col width="180" />
                            <col width="120" />
                            <col width="160" />
                            <col width="160" />
                            <col width="120" />
                            <col width="230" />
                            <col width="230" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <tr class="fixed_top">
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">구분</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">이름 (나이, 성별)</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">호실</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">진단명</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">본병원</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">식사구분</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">입원일 식이</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">식이비고</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">영양 메모</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">연락처</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">보호자연락처</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">기타사항</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="p-2 text-center nutrition_top" colspan="2" style="border-top: 0.2em solid rgb(67, 151, 152); font-size:16px; font-weight:bold;">
                                    확인중 ({{ nutritionCount_0 }}명)
                                </td>
                                <td style="border-top: 0.2em solid rgb(67, 151, 152);" colspan="10"></td>
                            </tr>
                            <tr>
                                <td colspan="12" style="height: 8px;"></td>
                            </tr>
                            <template v-for="(item, index) in nutritionList_0">
                                <tr :key="date + index + '_0'" :uid="item.PATIENT_UID" class="nutrition_0">
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NEW_RE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_INFO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_ROOM }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_TIME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NUTRITION_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PROTECTOR_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ item.MEMO }}</td>
                                </tr>
                            </template>
                            <tr v-show="nutritionList_0.length == 0" class="nutrition_0">
                                <td class="p-2 border border-solid d-theme-border-grey-light text-center" colspan="12">데이터가 존재하지 않습니다.</td>
                            </tr>

                            <!-- 조식 -->
                            <tr>
                                <td
                                    class="p-2 text-center nutrition_top"
                                    style="background-color:rgb(157,179,211); border-top: 0.2em solid rgb(157, 179, 211); font-size:16px; font-weight:bold;"
                                    colspan="2"
                                >
                                    조식 ({{ nutritionCount_1 }}명)
                                </td>
                                <td style="border-top: 0.2em solid rgb(157, 179, 211);" colspan="10"></td>
                            </tr>
                            <tr>
                                <td colspan="12" style="height:8px;"></td>
                            </tr>
                            <template v-for="(item, index) in nutritionList_1">
                                <tr :key="date + index + '_1'" :uid="item.PATIENT_UID" class="nutrition_1">
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NEW_RE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_INFO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_ROOM }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_TIME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NUTRITION_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PROTECTOR_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ item.MEMO }}</td>
                                </tr>
                            </template>
                            <tr v-show="nutritionList_1.length == 0" class="nutrition_1">
                                <td class="p-2 border border-solid d-theme-border-grey-light text-center" colspan="12">데이터가 존재하지 않습니다.</td>
                            </tr>

                            <!-- 중식 -->
                            <tr>
                                <td
                                    class="p-2 text-center nutrition_top"
                                    style="background-color:rgb(191,165,150); border-top:0.2em solid rgb(191,165,150); font-size:16px; font-weight:bold;"
                                    colspan="2"
                                >
                                    중식 ({{ nutritionCount_2 }}명)
                                </td>
                                <td style="border-top:0.2em solid rgb(191,165,150);" colspan="10"></td>
                            </tr>
                            <tr>
                                <td colspan="12" style="height:8px;"></td>
                            </tr>
                            <template v-for="(item, index) in nutritionList_2">
                                <tr :key="date + index + '_2'" :uid="item.PATIENT_UID" class="nutrition_2">
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NEW_RE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_INFO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_ROOM }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_TIME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NUTRITION_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PROTECTOR_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ item.MEMO }}</td>
                                </tr>
                            </template>
                            <tr v-show="nutritionList_2.length == 0" class="nutrition_2">
                                <td class="p-2 border border-solid d-theme-border-grey-light text-center" colspan="12">데이터가 존재하지 않습니다.</td>
                            </tr>

                            <!-- 석식 -->
                            <tr>
                                <td
                                    class="p-2 text-center nutrition_top"
                                    style="background-color:rgb(190,149,162); border-top:0.2em solid rgb(190,149,162); font-size:16px; font-weight:bold;"
                                    colspan="2"
                                >
                                    석식 ({{ nutritionCount_3 }}명)
                                </td>
                                <td style="border-top:0.2em solid rgb(190,149,162);" colspan="10"></td>
                            </tr>
                            <tr>
                                <td colspan="12" style="height:8px;"></td>
                            </tr>
                            <template v-for="(item, index) in nutritionList_3">
                                <tr :key="date + index + '_3'" :uid="item.PATIENT_UID" class="nutrition_3">
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NEW_RE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_INFO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_ROOM }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_TIME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NUTRITION_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PROTECTOR_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ item.MEMO }}</td>
                                </tr>
                            </template>
                            <tr v-show="nutritionList_3.length == 0" class="nutrition_3">
                                <td class="p-2 border border-solid d-theme-border-grey-light text-center" colspan="12">데이터가 존재하지 않습니다.</td>
                            </tr>

                            <!-- 익일 -->
                            <tr>
                                <td
                                    class="p-2 text-center nutrition_top"
                                    style="background-color:rgb(177, 167, 203); border-top:0.2em solid rgb(177, 167, 203); font-size:16px; font-weight:bold;"
                                    colspan="2"
                                >
                                    익일 ({{ nutritionCount_4 }}명)
                                </td>
                                <td colspan="10" style="border-top:0.2em solid rgb(177, 167, 203);"></td>
                            </tr>
                            <tr>
                                <td colspan="12" style="height:8px;"></td>
                            </tr>
                            <template v-for="(item, index) in nutritionList_4">
                                <tr :key="date + index + '_4'" :uid="item.PATIENT_UID" class="nutrition_4">
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NEW_RE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_INFO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_ROOM }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.SICKNESS }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_TIME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_NAME }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.MEAL_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.NUTRITION_MEMO }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PATIENT_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.PROTECTOR_PHONE }}</td>
                                    <td class="p-2 border border-solid d-theme-border-grey-light">{{ item.MEMO }}</td>
                                </tr>
                            </template>
                            <tr v-show="nutritionList_4.length == 0" class="nutrition_4">
                                <td class="p-2 border border-solid d-theme-border-grey-light text-center" colspan="12">데이터가 존재하지 않습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
// import store from '@/store/store';
export default {
    data() {
        return {
            date: '',
            day: '',
            nutritionList_0: [],
            nutritionList_1: [],
            nutritionList_2: [],
            nutritionList_3: [],
            nutritionList_4: [],
            nutritionCount_0: 0,
            nutritionCount_1: 0,
            nutritionCount_2: 0,
            nutritionCount_3: 0,
            nutritionCount_4: 0,
            width: window.innerWidth,
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async init() {
            await this.list();
        },
        async list() {
            this.$vs.loading({
                type: 'default',
                container: '#list',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            // this.date = '2021-10-06';
            const { data } = await axiosClass.get(`/api/nutrition/list/${this.date}`, {}, true);

            this.nutritionList_0 = data.lists.DATA_0 == '' ? [] : JSON.parse(data.lists.DATA_0);
            this.nutritionList_1 = data.lists.DATA_1 == '' ? [] : JSON.parse(data.lists.DATA_1);
            this.nutritionList_2 = data.lists.DATA_2 == '' ? [] : JSON.parse(data.lists.DATA_2);
            this.nutritionList_3 = data.lists.DATA_3 == '' ? [] : JSON.parse(data.lists.DATA_3);
            this.nutritionList_4 = data.lists.DATA_4 == '' ? [] : JSON.parse(data.lists.DATA_4);

            this.nutritionCount_0 = data.counts.COUNT_0;
            this.nutritionCount_1 = data.counts.COUNT_1;
            this.nutritionCount_2 = data.counts.COUNT_2;
            this.nutritionCount_3 = data.counts.COUNT_3;
            this.nutritionCount_4 = data.counts.COUNT_4;

            setTimeout(() => {
                this.$vs.loading.close('#list > .con-vs-loading');
            }, 100);
        },
        async updateDate(day) {
            if (day == -1) {
                this.date = dateClass.prevYYYYMMDD2(this.date);
            } else if (day == 1) {
                this.date = dateClass.nextYYYYMMDD2(this.date);
            }
            this.day = dateClass.getDay(this.date);
            await this.init();
        },
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize);
        await this.init();
    },
    created() {
        this.date = dateClass.dateYYYYMMDD3();
        this.day = dateClass.getDay(this.date);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style>
.calendar tbody tr td {
    padding: 10px;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 0.9rem;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}
/* table > thead > tr > th {
    font-weight: 400;
    background-color: blue;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    z-index: 1;
}
table > tbody > tr > td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
} */
.tb_box {
    overflow: auto;
}
.table_header {
    position: sticky;
    top: 0;
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}
.contentTable {
    font-size: 12px;
}
.headerBtn {
    background-color: rgba(241, 241, 241, 0.9);
    padding: 5px 10px;
}
.headerBtn a {
    padding: 5px;
}

.timeHeader {
    position: sticky;
    left: 0;
    z-index: 999;
}

.no_list {
    font-size: 18px;
}

td.nutrition_top {
    background-color: rgb(67, 151, 152);
    color: rgb(255, 255, 255);
    /* font-weight: bold; */
}
td.nutrition_bottom {
    border-bottom-style: solid;
    border-bottom-color: #bdbdbd;
    border-bottom-width: 0.1em;
}
.nutrition_0 > td {
    background-color: rgb(221, 231, 232);
}
.nutrition_1 > td {
    background-color: rgb(225, 232, 242);
}
.nutrition_2 > td {
    background-color: rgb(232, 225, 222);
}
.nutrition_3 > td {
    background-color: rgb(221, 210, 214);
}
.nutrition_4 > td {
    background-color: rgb(231, 228, 239);
}
</style>
